import { render, staticRenderFns } from "./Evaluacion.vue?vue&type=template&id=0aa300be&"
import script from "./Evaluacion.vue?vue&type=script&lang=js&"
export * from "./Evaluacion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports